import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import PopupMenu from 'tivigi/src/components//PopupMenu/PopupMenu'

import SmartButton from 'tivigi/src/components/SmartButton/SmartButton';
import RangeSlider from 'tivigi/src/components/RangeSlider/RangeSlider'

import WithRender from './ConfigMenu.html';


import './ConfigMenu.scss'

// TO DO: Styling and replace PopupMenu with simple div

@WithRender
@Component({
    components: {
        Superbutton,
        PopupMenu,
        RangeSlider,
        SmartButton,
        
    }
})
export default class ConfigMenu extends Vue {

    @Prop()
    config:any

    @Prop()
    trigger!:boolean

    mode:string="walking_standard"

    minutes:number = 10
    speed: number = 5

    show = false

    isochroneConfig:any = {

        "routing_profile":this.mode,
        "speed": this.speed,
        "minutes": this.minutes

    }

    //initialize default config, otherwise config == undefined
    mounted()
    {
        this.$emit('update:config', this.isochroneConfig)
    }

    @Watch('trigger')
    onTriggerChange(){
        this.show = this.trigger
    }

    //uncheck config button at closing of popUp Menu
    @Watch('show')
    onDisplayChnage()
    {
        if(this.show == false){
            this.$emit('update:trigger', false)
        }
    }

    closeMenu(){
        
        this.setConfig()
        this.show = false

    }

    setConfig(){
        this.isochroneConfig.speed = this.speed
        this.isochroneConfig.minutes = this.minutes
        this.isochroneConfig.routing_profile = this.mode

    }


    @Watch('mode')
    onModeChange()
    {
        if(this.mode=="walking_standard"){

            this.speed = 5
            this.minutes = 10

        }
        if(this.mode =="cycling_standard"){

            this.speed = 15
            this.minutes = 10

        }

    }




}
